@if (playbackState$ | async; as playbackState) {
    <div class="flex row justify-space-between">
        <div class="flex-5 play-button">
            <button (click)="play()">
                <mat-icon class="filled">{{ playbackState.isPlaying ? "pause" : "play_arrow" }}</mat-icon>
            </button>
        </div>
        <div
            #slider
            class="flex time-slider"
            (mousedown)="mouseDownHandler($event)"
            (contextmenu)="contextMenuHandler($event)"
        >
            <div class="mousetrap"></div>
            @if (buffered$ | async) {
                <canvas #buffer [width]="sliderWidth" [height]="bufferHeight"></canvas>
            }
            <div class="frame-indicator" [style.left.%]="offset">
                <div class="current-frame-indicator" [class.hidden]="playbackState.isPlaying">
                    {{ frame }}
                </div>
                <div></div>
            </div>

            @for (annotationFrame of annotations$ | async; track $index) {
                @if (annotationFrame.offset >= 0) {
                    <div class="frame-indicator annotation-frame" [class.annotation-drawing-frame]="annotationFrame.hasDrawing" [style.left.%]="annotationFrame.offset">
                        <svg width="5" height="5">
                            <polygon points="0,5 5,5 2.5,0"></polygon>
                        </svg>
                    </div>
                }
            }

            <span class="flex justify-center align-items-center timeline-info noselect">
                {{ playbackState.frameCount }} frames, {{ playbackState.frameRate | number: '1.0-0' }} fps
            </span>

            @if (timeRange.isValid) {
                <div
                    class="time-range"
                    [style.left.%]="startRangeOffset"
                    [style.width.%]="endRangeOffset"
                ></div>
            }
        </div>
        <div class="flex-5 frame-counter">
            {{ frame }}
        </div>
    </div>
}
